__turbopack_context__.v({
  "checkIcon": "AttendeesRow-module-scss-module__R-bdhq__checkIcon",
  "label": "AttendeesRow-module-scss-module__R-bdhq__label",
  "labelContainer": "AttendeesRow-module-scss-module__R-bdhq__labelContainer",
  "labelYou": "AttendeesRow-module-scss-module__R-bdhq__labelYou",
  "root": "AttendeesRow-module-scss-module__R-bdhq__root",
});
